import { useRouteMatch } from 'react-router';

import { Route as Routes } from 'src/shared/route';

export const useIsFullscreenSharedPage = (): boolean =>
  !!useRouteMatch(Routes.PROJECT_SHARE_FULLSCREEN.path);
